import { apiBase } from "@apis/index";

export const getRequestDetail = (actionSeq, verificationTypeCd) => {
  return apiBase({
    method: "GET",
    url: `action/${actionSeq}`,
    params: {
      verificationTypeCd: verificationTypeCd,
    },
  });
};

export const getAssigneesByProjectSeq = (projectSeq) => {
  return apiBase({
    method: "GET",
    url: "user_assignee",
    params: {
      projectSeq: projectSeq,
    },
  });
};
